
import { NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { environment } from 'src/environments/environment';

export const CookieConsentConfiguration : NgcCookieConsentConfig = {

    cookie: {
        domain: environment.cookieDomain
    },

    position: 'bottom',
    theme   : 'edgeless',

    palette: {
        popup: {
            background: '#000000',
            text      : '#FFFFFF'
        },
        button: {
            background: '#F1D600',
            text      : '#000000'
        }
    },

    type: 'info',
    content: {
        message: 'Las cookies nos ayudan a proporcionar nuestros servicios. Usando nuestros servicios, está de acuerdo con nuestro uso de cookies.',
        dismiss: 'Aceptar',
        deny   : 'Refuse cookies',
        link   : 'Aprender más',
        href   : '/politica-cookies',
        policy : 'Política de cookies'
    }
    
};
